import React, { useImperativeHandle, useState, useCallback, forwardRef } from 'react'
import { withUIContext } from 'context'
import { Form } from 'antd'
import { Text } from 'components/common'

const FormContainer = forwardRef(({ layout, className, loadingBtnLogic, ...props }, ref) => {

    const [form] = Form.useForm()

    useImperativeHandle(ref, () => {
        return form
    })

    const [error, setError] = useState()

    const onValuesChange = (newVal, values) => {
        props.onChange && props.onChange(newVal, values, form)
    }

    const onFinish = useCallback((values) => {
        form.setFields([])
        setError('');
        loadingBtnLogic();

        props
            .onFinish(values)
            .then((res) => {
                Promise.resolve(res)
                setTimeout(() => {
                    loadingBtnLogic();
                }, 300);
            })
            .catch((err) => {
                if (err?.data) {
                    let formValues = []

                    if (typeof err.data.message === 'string') {
                        setError(err.data.message)
                    }

                    for (let key in values) {
                        formValues.push({
                            name: key,
                            value: values[key],
                            errors: err.data?.messages?.[key]?.[0] ? [[err.data.messages[key]][0]] : '',
                        })
                    }
                    form.setFields(formValues)
                }

                Promise.reject(err?.data)
            })
    }, [error, props.onFinish])

    const onFinishFailed = ({ errorFields }) => {
        if (errorFields[0].name[0] == 'avatar') {
            window.scrollTo(0, 0)
        } else {
            form.scrollToField(errorFields[0].name, 'smooth');
        }
    };

    return (
        <div>
            <Form
                layout={layout || 'vertical'}
                initialValues={props.initialValues}
                onFinish={onFinish}
                onValuesChange={onValuesChange}
                onFinishFailed={onFinishFailed}
                form={form}
                className={className || ''}
                scrollToFirstError
            >
                {error && (
                    <div className='globalErrorWrap PopReg'>
                        <Text tag={'p'} className={'errorColor h5'} text={error} />
                    </div>
                )}
                {props.children}
            </Form>
        </div>
    )
})

export default withUIContext(FormContainer, ['loadingBtnLogic'])
